import { isOk } from './result';

export const WILDCARD_FORMAT = '*';

const REGEX_VALID_NUMBER = /^([+-]?\d*)(\.((\d+)?))?$/;

export const isNumberFormatValid = (format: string): boolean => {
  return format === WILDCARD_FORMAT || format === '.' || format === ',';
};

export function parseNumber(value: string) {
  // Strip thousand's separators (strictly spaces, not all whitespace characters)
  const normalized = value.replaceAll(/ /gi, '').trim();

  if (!REGEX_VALID_NUMBER.test(normalized)) {
    return { errors: ['invalid_number'] };
  }

  const number = parseFloat(normalized);
  if (isNaN(number)) {
    return { errors: ['invalid_number'] };
  }
  return { value: number };
}

export function isNumberInFormat(value: string): boolean {
  return isOk(parseNumber(value));
}
